import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  components: {
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true
      }
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
        // variant: "contained"
      },
      styleOverrides: {
        root: {
          // borderRadius: 0
        }
      }
    }
  },
  mixins: {
    toolbar: {
      minHeight: 80
    }
  },
  palette: {
    background: {
      imagePlaceholder: "#666",
      paper: "#2f3640",
      paperAlt: "#3f4650",
      footer: "#222"
    },
    imagePlaceholder: {
      main: "#aaa"
    },
    primary: {
      main: "#b59354"
    },
    text: {
      primary: "#f0f0f0",
      secondary: "#bbb"
    },
    mode: "dark"
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica Neue", "Helvetica", "Arial", "sans-serif"',
    fontSize: 18
  }
});

export default theme;
